// src/components/Welcome.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Countdown from "./Countdown"; 
import "../styles/Welcome.css"; 
import { Link } from "react-router-dom"; 


const today = new Date(); 

const hideDate = new Date("2025-12-20T00:00:00");
const hideButton = today >= hideDate;

const votingStart = new Date("2025-12-20T00:00:00");
const votingEnd   = new Date("2025-12-24T23:59:59");

const showVoteButton = today >= votingStart && today <= votingEnd;




const Welcome = () => {
  const navigate = useNavigate();

  const handleRegisterClick = () => {
    navigate("/register");
  };
const handleMapClick = () => {
  navigate("/holidayLight-map");
};
const handleVoteClick = () => {
  navigate("/voting");
}

  // --- Subscription form state ---
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");

  const handleSubscribe = async (e) => {
    e.preventDefault();

    if (!email) {
      setError("Please enter a valid email.");
      return;
    }

    try {
      const res = await fetch("/api/subscribe", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      if (res.ok) {
        setSubmitted(true);
        setError("");
        setEmail("");
      } else {
        setError("Failed to subscribe. Try again later.");
      }
    } catch (err) {
      setError("Error connecting to server.");
    }
  };

  return (
    <div className="welcome-page">
      {!hideButton && (
      <Countdown />
      )}
{showVoteButton && (
  <div className="vote-btn-container2">
    <button className="vote-btn2" onClick={handleVoteClick}>
      Vote Now
    </button>
  </div>
)}

      <h1>
        Tamarac Relaunches Neighborhood Holiday Lights Contest for a Second Year
      </h1>

      <p>
        Back by popular demand, the City of Tamarac is pleased to announce the return of its
        Second Annual Neighborhood Holiday Lights Contest, inviting residents to brighten the
        season with creativity, sparkle and community spirit. After an enthusiastic response
        from residents last year, Tamarac is delighted to bring this festive competition back
        for 2025.
      </p>

      <p>
        This year’s contest once again encourages households across the City to transform their
        homes into glowing displays of holiday cheer.
      </p>

      <h2 className ='mainTitle'>Prizes</h2>
      <p>Residents will compete for three gift card prizes:</p>
      <ul>
        <li>1st Place: $75 gift card</li>
        <li>2nd Place: $50 gift card</li>
        <li>3rd Place: $25 gift card</li>
      </ul>

      <p>
        In addition to the gift cards, all three winning homes will receive a special “Holiday
        Lights Contest Winner” lawn sign to proudly display their achievement.
      </p>

      <h2 className ='mainTitle'>How to Enter</h2>
      <p>
        Participants must be Tamarac residents. To enter, visit{" "}
        <a
          href="https://www.tamarac.gov/LightingContest"
          target="_blank"
          rel="noopener noreferrer"
        >
          Tamarac.gov/LightingContest
        </a>{" "}
        beginning December 1, 2025, and upload photos or videos (up to 50MB) of your decorated home no later than
        December 19, 2025.
      </p>


      <h2 className ='mainTitle'>How to Vote</h2>
      <p>
        From December 20 to 24, 2025, the community is invited to visit the same link to vote
        for their favorite holiday light displays. Every vote helps shine a spotlight on
        Tamarac’s most festive homes and celebrates the creativity of our neighbors.
      </p>
{showVoteButton && ( 
  <button className="register-btn" onClick={handleVoteClick}> 
  Vote Now </button> 
)}
      <h2 className ='mainTitle'>Winners Announced</h2>
      <p>
        The top three homes with the most votes will be announced on December 26, 2025, on the
        City of Tamarac’s social media channels.
      <br />
        For more information about the contest contact the City of Tamarac’s Public Information Office at{" "}
        <a href="tel:+19545973523">(954) 597- 3523</a>.
      </p>
{!hideButton && (
      <button className="register-btn" onClick={handleRegisterClick}>
        Register Now
      </button>
)}
 <h2 className ='mainTitle'>Explore the Holiday Lights Map</h2>
 <p>
  Discover the magic of Tamarac’s neighborhoods this holiday season! 
  The Holiday Lights Map showcases all the homes participating in the contest, 
  making it easy for you and your family to plan a festive evening drive 
  and enjoy the dazzling displays across the city.
</p>

   <button className="register-btn" onClick={handleMapClick}>
        Discover Contest Entries on the Map
      </button>

<h2 className ='mainTitle'>Subscribe to Entry Updates</h2>

<p className="subscribe-description">
  Want to be the first to know when new homes join the contest?
  Stay in the loop, catch the most dazzling displays, and never miss a single sparkling entry!
</p>

<div className="subscribe-form">
  {submitted ? (
    <p className="subscribe-success">
      🎉 You're subscribed! You'll now receive updates when new homes enter the contest.
    </p>
  ) : (
    <form onSubmit={handleSubscribe} className="subscribe-flex">
      <input
        type="email"
        placeholder="Enter your email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        required
      />

      <button type="submit" className="subscribe-btn">
        Subscribe
      </button>
    </form>
  )}

  {error && <p className="subscribe-error">{error}</p>}
</div>


    </div>
  );
};

export default Welcome;
